export const transformCategoryCase = function () {
  let taxName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return taxName[1] === taxName[1]?.toLowerCase() ? taxName.charAt(0).toLowerCase() + taxName.substring(1, taxName.length) : taxName;
};